var _rect, _path, _path2, _g, _rect2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBnd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2402_3519",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2402_3519)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "#FFD221"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2402_3519",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 23,
    height: 23
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0V23H23V0H0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2402_3519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.20435 10.173L-0.761103 5.78467L24.2706 20.4203L22.8273 24.8086L-2.20435 10.173Z",
    fill: "#313131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.1687 5.33737L-0.726063 0.94873L25.5504 16.3045L24.1078 20.6932L-2.1687 5.33737Z",
    fill: "#FAF9F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 2.76709C11.103 2.76709 10.7813 3.19615 10.7813 3.72542V7.20289C10.5362 7.04326 10.219 6.90005 9.86978 6.90005C9.08083 6.90005 8.19375 8.37201 8.19375 8.37201C8.19375 8.37201 9.65951 8.42515 10.7813 9.90901V15.2252C9.54061 14.7879 9.00772 13.1036 9.14774 9.66123L6.99465 9.50555C6.76985 15.0324 8.30082 18.2182 11.53 18.2182C14.7425 18.2182 16.3266 15.0614 16.2194 9.54615L14.0638 9.62063C14.1322 13.1359 13.5305 14.8411 12.2188 15.2464V9.72865C13.3179 8.42076 14.6625 8.37201 14.6625 8.37201C14.6625 8.37201 13.7754 6.90005 12.9865 6.90005C12.7021 6.90005 12.439 6.99501 12.2188 7.11647V3.72542C12.2188 3.19615 11.897 2.76709 11.5 2.76709ZM4.18314 10.5261C3.79267 10.4308 3.53405 9.93154 3.60549 9.41091C3.67694 8.89028 4.05139 8.54545 4.44187 8.64071C5.87788 8.99104 6.65854 10.3231 6.65854 12.36V16.2419C6.65854 16.7712 6.33674 17.2002 5.93979 17.2002C5.54283 17.2002 5.22104 16.7712 5.22104 16.2419V12.36C5.22104 11.2241 4.91684 10.7051 4.18314 10.5261ZM19.4404 9.41091C19.5119 9.93154 19.2532 10.4308 18.8628 10.5261C18.1291 10.7051 17.8249 11.2241 17.8249 12.36V16.2419C17.8249 16.7712 17.5031 17.2002 17.1061 17.2002C16.7092 17.2002 16.3874 16.7712 16.3874 16.2419V12.36C16.3874 10.3231 17.168 8.99104 18.6041 8.64071C18.9945 8.54545 19.369 8.89028 19.4404 9.41091ZM7.0015 17.6712L8.18947 16.592C8.85502 17.8945 9.93016 18.5485 11.5 18.5485C13.0801 18.5485 14.0772 18.0393 14.5664 17.0944L15.7494 18.1832C14.9491 19.729 13.5076 20.4652 11.5 20.4652C9.48213 20.4652 7.95426 19.5357 7.0015 17.6712Z",
    fill: "#CF1225"
  })))), /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "url(#paint0_linear_2402_3519)",
    style: {
      mixBlendMode: "overlay"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22,
    height: 22,
    rx: 11,
    stroke: "black",
    strokeOpacity: 0.1
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2402_3519",
    x1: 11.5,
    y1: 0,
    x2: 11.5,
    y2: 23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.7
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.3
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBnd);
export default __webpack_public_path__ + "static/media/BND.ddcf5f0a7eab35993968c44fb3869c6b.svg";
export { ForwardRef as ReactComponent };